import { render, staticRenderFns } from "./share_worklist_dialog.vue?vue&type=template&id=f95732c4"
import script from "./share_worklist_dialog.vue?vue&type=script&lang=js"
export * from "./share_worklist_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports